/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useMemo, useState } from "react";
import "./CRM.scss";
import CustomerProfile from "../../components/CustomerProfile/CustomerProfile";
import CustomerTabs from "../../components/CustomerTabs/CustomerTabs";
import TableFilterHeader from "../../components/TableHeader/TableFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import { getUserList, setStoreSelectedUser } from "../../store/redux/users";
import {
  addToPreviousUsers,
  removeFromPreviousUsers,
} from "../../store/redux/previousUsers";
import { getUserDetails, getUserDetailsNew } from "../../util/API/customers";
import CustomUserModal from "../../components/CustomUserModal/CustomUserModal";
import LoadingPage from "../../components/UI/LoadingPage/LoadingPage";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import TableInfoCRM from "../../components/TableInfoHeader/TableInfoCRM";
import BaseModal from "../../components/UI/BaseModal/BaseModal";
import FilterModalCRM from "../../components/FilterModal/FilterModalCRM";
import { setUserID } from "../../store/redux/users";
import CRMTableDynamic from "../../components/CRMTableDynamic/CRMTableDynamic";
import { crmTable } from "../../constants/tables";
import { getTableData } from "../../util/API/tableServices";
import { Box, Collapse, Typography, Button, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import BaseDrawer from "../../components/UI/BaseDrawer/BaseDrawer";
import TransferDrawer from "../../components/TransferDrawer/TransferDrawer";
import CustomMoneyGramModal from "../../components/CustomMoneyGramModal/CustomMoneyGramModal";
import CustomAlert from "../../components/UI/CustomAlert/CustomAlert";
import { getModulePermissions } from "../../util/API/customers";
import UserFace from "../../images/user.png";


function CRM() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [previousUsers, setPreviousUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [openMoneyGramModel, setOpenMoneyGramModel] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState(null);
  const [countryFilter, setCountryFilter] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [securityPermissions, setSecurityPermissions] = useState([]);
  const [openButton, setOpenButton] = useState({
    edit: false,
    settings: false
  })
  const [userRoles, setUserRoles] = useState([]);
  const [roleChanged, setRoleChanged] = useState(false);
  const [profileStatusChanged, setProfileStatusChanged] = useState(false);
  const [customerTabsHeight, setCustomerTabsHeight] = useState(window.innerHeight * 0.6);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [filterRole, setFilterRole] = useState([]);
  const [isAssociateAgent, setIsAssociateAgent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    showAlert: false, 
    severity: '',
    message: '',
    header: ''
  })
  const [tabPermissions, setTabPermissions] = useState()

  let isAdmin = sessionStorage.getItem("isAdmin");
  let isSuperAdmin = sessionStorage.getItem("isSuperAdmin");
  const requiredConstants = useSelector((state) => state.constants);
  let configVariables = useSelector((state) => state.config.baseConfig);
  let imageUrl = configVariables.imageURL;

  useEffect(() => {
    const updateHeights = () => {
      const adjustedHeight = window.innerHeight * 0.635; // Adjust height dynamically
  
      setCustomerTabsHeight(adjustedHeight);
    };
  
    // Set initial heights
    updateHeights();
  
    // Update heights on window resize
    window.addEventListener("resize", updateHeights);
    return () => window.removeEventListener("resize", updateHeights);
  }, []);

  //Security Roles
  const securityAccess = useSelector((state) => state.login.securityAccess);
  const securityRole = useSelector((state) => state.login.securityRole);

  const getUserRoles = async() => {
    setUserRoles(requiredConstants.systemRoles);
  }

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const getChildAccess = async() => {
    let response = await getModulePermissions(agent['User'].id, "Parent");
    setTabPermissions(response?.children)
  }

  useEffect(() => {
    // Allow the user to edit user profile or not
    const securityUser = searchAppsByLabel("crm", securityAccess);

    if (securityUser.length) { setSecurityPermissions(securityUser[0]); }
    else if (typeof securityUser === "object") { setSecurityPermissions(securityUser); }
    getChildAccess();

    setIsCollapsed(false);
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleMoneyGramClose = () => setOpenMoneyGramModel(false);
  const handleFilterOpen = () => setOpenFilter(true);
  const handleFilterClose = () => setOpenFilter(false);

  const dispatch = useDispatch();
  let userData = useSelector((state) => state.usersList.users);
  const previousUserData = useSelector((state) => state.previousUsers.previousUsers);  

  const closeTransfers = () => setOpenButton((prev) => ({...prev, settings: false}));

  const fetchTable = async (limit=100, page=1, searchText="", edit=true) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      let response = await fetch(`/tables/crmTable.json`);
      const formResponseData = await response.json();
      const userDataResponse = await getTableData(
        formResponseData.services, 
        { limit: page > 1 ? limit : 100, page: page, searchText: searchText }
      );

      if (userDataResponse?.payload === "" && !edit) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "No user records found.",
          header: "Error",
        });
        return; 
      }

      dispatch(getUserList({ users: userDataResponse }));
    } catch (error) {
      console.error("Failed to fetch form data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useMemo(() => {
    fetchTable();
    getUserRoles();
  }, []);

  useEffect(() => {
    if (userData && userData?.payload) {
      let users = Array.isArray(userData?.payload?.record) ? userData?.payload?.record : [userData?.payload?.record];
      let filtered = users?.filter
      (
        user => 
        user?.Vuser?.profilestatusname !== "Temp"
        &&
        user?.Vuser?.profilestatusname !== "Unconfirmed"
      );

      if (filterType?.label === "Closed") filtered = filtered.filter((user) => user?.Vuser?.statusname === "Closed");

      if (filterType?.value && filterType?.label !== "Closed") 
        filtered = filtered.filter((user) => user?.Vuser?.profilestatus === filterType?.value);

      if (countryFilter) { filtered = filtered.filter((user) => user?.Vuser?.countryid === countryFilter.value); }

      filtered.sort((a, b) => b?.Vuser?.id - a?.Vuser?.id);
      setFilteredUsers(filtered);
    }
  }, [userData, filterType, countryFilter, filterRole]);

  const setFilter = (filter) => { setFilterType(filter); };

  //This is to get the user details when a user is selected
  const handleSelectedUser = async (selectedCustomerID, selectedCustomer, actionName) => {
    selectedCustomerID ? setSelectedUser(selectedCustomerID) : setSelectedUser(selectedCustomer);
    //get user details of the selected user based on the id
    const userDetails = await getUserDetailsNew(selectedCustomerID ? selectedCustomerID : selectedCustomer);
    //adds it to prevoius user list
    updatePreviousUsers(userDetails.User);

    dispatch(addToPreviousUsers({ users: userDetails.User }));
    dispatch(setStoreSelectedUser({selectedUser: userDetails}))

    setSelectedUserData(userDetails);

    dispatch(setUserID({ userID: userDetails }));

    if (actionName === 'edit') { setOpenButton(prevState => ({ ...prevState, edit: true })) } 
    else if (actionName === 'settings') { setOpenButton(prevState => ({ ...prevState, settings: true })) }
  };

  //Adding to the recently view user list
  function updatePreviousUsers(selectedCustomer) {
    const indexOfCustomer = previousUsers.findIndex( (user) => user.id === selectedCustomer.id );

    if (indexOfCustomer === -1) {
      if (previousUsers.length >= 5) {
        setPreviousUsers((prevUsers) => [
          ...prevUsers.slice(0, 4),
          selectedCustomer,
        ]);
      } else {
        setPreviousUsers((prevUsers) => [selectedCustomer, ...prevUsers]);
      }
    } else {
      const updatedUsers = [
        selectedCustomer,
        ...previousUsers.slice(0, indexOfCustomer),
        ...previousUsers.slice(indexOfCustomer + 1),
      ];
      setPreviousUsers(updatedUsers);
    }
  }

  //Remove from recently viewed user
  const deleteItemById = (idToDelete) => { dispatch(removeFromPreviousUsers(idToDelete)); };


  //Searches based on firstname, email, or telephone number
  const handleSearch = (searchText) => {
    const trimmedSearchText = searchText.trim();
    setSearchText(trimmedSearchText);
    fetchTable(100, 1, trimmedSearchText, false);
  };

  const conditionalFields = {
    peppersons: (value, watch) => watch("politicallyexposed") === "1",
    merchantFirstName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    merchantLastName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    merchantphoneno: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress1: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress2: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscityname: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscountryidlist: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessstateid: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesszip: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    industry: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    legalstructure: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    email: (value, watch) => watch("defaultLogin") === "1",
  };

  const customerProfileConditionalFields = {
    peppersons: (value, watch) => watch("politicallyexposed") === "1",
    merchantFirstName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    merchantLastName: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessname: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessphoneno: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress1: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessaddress2: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscity: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesscountry: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businessstate: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    businesszipcode: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    industry: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
    legalstructure: (value, watch) => watch("ismerchant") === true || watch("ismerchant") === "true",
  }

  const onCreate = (userID) => {
    handleSelectedUser(userID); 
    setOpenButton(prevState => ({ ...prevState, edit: true }))
  }

  useEffect(() => {
    fetchTable();
  }, [roleChanged]);

  return (
    <>
      {filteredUsers && securityPermissions ? (
        <>
          <BaseModal />
          <FilterModalCRM
            open={openFilter}
            handleClose={handleFilterClose}
            setFilter={setFilter}
            setCountryFilter={setCountryFilter}
            filters={crmTable.filters}
          />
          <CustomUserModal 
            open={open} 
            handleClose={handleClose} 
            updateState={fetchTable} 
            conditionalFields={conditionalFields} 
            onCreate={onCreate}
          />
          <CustomMoneyGramModal 
            open={openMoneyGramModel} 
            handleClose={handleMoneyGramClose} 
            updateState={fetchTable} 
            onCreate={onCreate}
          />
          <Box className="page-container crm-container">
            <Box>
              <Box className={`page-title`}>
                <Box className="crm-row-style">
                  <Box
                    className={scrollPosition > 105 ? "hide" : "padding-header"}
                  >
                    CRM
                  </Box>
                  <TableFilterHeader
                    handleSearch={handleSearch}
                    createAllowed={securityPermissions?.createallowed}
                    setOpen={handleOpen}
                    setOpenMoneyGramModel={setOpenMoneyGramModel}
                    isAdmin={isAdmin}
                    pageName={"CRM"}
                  />
                </Box>
              </Box>
            </Box>

            <Box className="customer-table-container">
              <TableInfoCRM
                count={filteredUsers.length}
                setFilter={setFilter}
                setCountryFilter={setCountryFilter}
                openModal={handleFilterOpen}
                previousUserData={previousUserData}
                handleSelectedUser={handleSelectedUser}
                setOpenButton={setOpenButton}
                deleteItemById={deleteItemById}
                countryFilter={countryFilter}
                filterType={filterType}
                filterRole={filterRole} 
                setFilterRole={setFilterRole} 
                systemRoles={userRoles}
              />

              {crmTable && <CRMTableDynamic
                userData={filteredUsers}
                handleSelectedUser={handleSelectedUser}
                editAllowed={securityPermissions.updateallowed}
                selectedUser={selectedUser}
                selectedUserData={selectedUserData}
                targetID="offcanvasRight"
                filterType={filterType}
                searchText={searchText}
                systemRoles={userRoles}
                fetchTable={fetchTable}
              />
              }
            </Box>

            <Box
              class="offcanvas offcanvas-end dynamic-offcanvas"
              tabindex="-1"
              id="offcanvasRight"
              aria-labelledby="offcanvasRightLabel"
            >
              <Box class="customer-bottom-info">
                <Box class="text-end p-2">
                  <Button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></Button>
                </Box>
                <Box class="accordion" id="profileAccordion">
                  <Box class="accordion-item">
                    <Typography variant="h2" class="accordion-header" id="headingOne">
                      <Button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        {`Customer Details: ${selectedUserData?.User?.id || 'N/A'} - ${selectedUserData?.User?.firstName || 'N/A'} ${selectedUserData?.User?.lastName || 'N/A'}`}
                      </Button>
                    </Typography>
                    <BaseDrawer
                      open={openButton.edit}
                      handleClose={() => setOpenButton((prevState) => ({ ...prevState, edit: false }))}
                      height="90vh"
                    >
                    <Box sx={{ padding: '22px', marginBottom: "80px" }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box />
                      </Box>

                      <Box sx={{ marginBottom: '16px' }} />

                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '16px',
                        }}
                      >
                        <Box
                          sx={{
                            flex: isCollapsed ? '0 0 15%' : '1', // Collapse to 100px width
                            maxWidth: isCollapsed ? '25%' : '50%',
                            paddingBottom: "100px",
                            '@media (min-width: 1920px)': {
                              marginLeft: isCollapsed ? '0' : '50px',
                            },
                            transition: 'all 0.3s ease-in-out',
                          }}
                        >
                          <Box 
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              backgroundColor: '#ffffff',
                              cursor: 'pointer',
                            }}
                            onClick={() => setIsCollapsed(!isCollapsed)}
                          >
                            <Typography
                              sx={{
                                position: "absolute",
                                left: "30px",
                                top: "67px",
                                fontFamily: "'Nunito'",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "21.4825px",
                                color: "#3A3A3A",
                                zIndex: 0,
                                '@media (min-width: 1920px)': {
                                  marginLeft: '50px'
                                },
                              }}
                            >
                              Customer Details
                            </Typography>
                            <IconButton 
                              onClick={() => setIsCollapsed(!isCollapsed)} 
                              sx={{ 
                                position: "absolute",
                                left: isCollapsed ? "15%" : "45%",
                                top: "67px", 
                                }}>
                              {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
                            </IconButton>
                          </Box>

                          <Collapse in={!isCollapsed} timeout="auto" unmountOnExit className="CRM-collapse-container">
                            <CustomerProfile
                              selectedUser={selectedUser}
                              open={openButton.edit}
                              editAllowed={securityPermissions.updateallowed == 0}
                              conditionalFields={customerProfileConditionalFields}
                              handleClose={() => { setOpenButton({ ...openButton, edit: false }); fetchTable(100, 1, searchText); }}
                              systemRoles={userRoles}
                              fetchTable={fetchTable}
                            />
                          </Collapse>

                          <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
                            <Box 
                              className="customer-porfile-collapsed-container"
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                padding: "20px",
                                gap: "20px",
                                overflow: "auto",
                              }}
                            >
                              <Box sx={{fontSize: "13px"}}>
                                <Box className="mb-4">
                                  <img
                                    className="user-profile"
                                    // src={
                                    //   selectedUserData?.selfieDoc?.split('|')[0]?.photo == imageUrl || selectedUserData?.selfieDoc?.split('|')[0]?.photo?.photo == "" || selectedUserData?.selfieDoc?.split('|')[0]?.photo?.status !== "2"
                                    //     ? UserFace
                                    //     : selectedUserData?.selfieDoc?.split('|')[0]?.photo
                                    // }
                                    src={
                                      selectedUserData?.selfieDoc?.split('|')[0] ? selectedUserData?.selfieDoc?.split('|')[0] : UserFace
                                    }
                                    loading="lazy"
                                  />
                                </Box>
                                <Box className="mt-2 d-flex">
                                  <b>User ID: </b>
                                  {selectedUser}
                                </Box>
                                <Box className="mt-2">
                                  <b>Name: </b>
                                  {selectedUserData?.User?.firstName} {selectedUserData?.User?.lastName}
                                </Box>
                                <Box className="mt-2">
                                  <b>Account Id: </b>
                                  {selectedUserData?.User?.accountID}
                                </Box>
                                <Box className="mt-2">
                                  <b>Contact No.: </b>
                                  {selectedUserData?.User?.contactPhoneNo}
                                </Box>
                                <Box className="mt-2">
                                  <b>Country Id: </b>
                                  {selectedUserData?.User?.countryid}
                                </Box>
                              </Box>
                            </Box>
                          </Collapse>
                        </Box>

                        <Box
                          sx={{
                            flex: 1,
                            minWidth: '50%',
                            overflowY: 'auto',
                            overflowX: "auto",
                            marginLeft: '15px',
                            backgroundColor: "white",
                            height: customerTabsHeight,
                            '@media (min-width: 1920px)': {
                              minHeight: "725px",
                              marginLeft: '15px',
                              marginRight: '50px',
                            },
                            transition: 'all 0.3s ease-in-out',
                          }}
                        >
                          <Typography
                            sx={{
                              position: "absolute",
                              top: "67px",
                              fontFamily: "'Nunito'",
                              fontStyle: "normal",
                              fontWeight: 500,
                              fontSize: "21.4825px",
                              color: "#3A3A3A",
                              zIndex: 0
                            }}
                          >
                            Service and Account Information
                          </Typography>

                          <CustomerTabs
                            selectedUser={selectedUser}
                            selectedUserData={selectedUserData}
                            setSelectedUserData={setSelectedUserData}
                            setRoleChanged={setRoleChanged}
                            setProfileStatusChanged={setProfileStatusChanged}
                            updateTableStatus={() => fetchTable(100, 1, searchText)}
                            roleChanged={roleChanged}
                            handleSelectedUser={handleSelectedUser}
                            isAssociateAgent={isAssociateAgent}
                            isSuperAdmin={isSuperAdmin}
                            handleClose={() => setOpenButton((prevState) => ({ ...prevState, edit: false }))}
                            tabPermissions={tabPermissions}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </BaseDrawer>
                  </Box>
                </Box>
              </Box>
            </Box>
            {openButton.settings && 
            <TransferDrawer 
              selectedUser={selectedUser} 
              selectedUserData={selectedUserData} 
              isOpen={openButton.settings} 
              closeTransfers={closeTransfers}
              updateTableStatus={fetchTable}
            />}
          </Box>
        </>
      ) : (
        <LoadingPage />
      )}
      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prev) => setAlert({...prev, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
    </>
  );
}

export default CRM;
